import { useContext } from 'react';

import FullPageHomeLoader from '../../components/FullPageHomeLoader';
import Layout from '../../components/Layout';
import { PartnerContext } from '../../config/PartnerContext';
import { GetSessionData_session_human } from '../../graphql/queries/__generated__/GetSessionData';
import { LegacyReportingDashboard, REPORTING_DASHBOARD_NAME } from './LegacyReportingDashboard';

export const ReportingDashboardWrapper = () => {
  const { partnerIdentifier } = useContext(PartnerContext);

  const renderLoader = () => <FullPageHomeLoader />;
  const loadingScreen = <Layout renderContent={renderLoader} />;

  if (!partnerIdentifier) {
    return loadingScreen;
  }

  return <LegacyReportingDashboard />;
};

ReportingDashboardWrapper.dashboardName = REPORTING_DASHBOARD_NAME;
ReportingDashboardWrapper.isAuthorized = (human: GetSessionData_session_human) =>
  human.has_partnership_reporting_dashboard;

export default ReportingDashboardWrapper;
